export default "__VITE_ASSET__DOlUd9bN__"